import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";  // ✅ added
import "./Home.css";
import "./Carousel.css";
 import './infrastructure.css';
 import Popup from "./popup";


const slides = [
  {
    img: "/4.jpg",
    title: "SMALL RPC",
    description:
      "Small RPC , Big Opportunities -- Take control of the skies today!",
  },
  {
    img: "/5.jpg",
    title: "MEDIUM RPC",
    description:
      "Turn your passion into profession - Medium RPC is the next level of drone mastery!",
  },
  {
    img: "/Add on Course Images/Sathya akka With students .jpg",
    title: "SMALL + MEDIUM RPC",
    description:
      "Small RPC to start, Medium RPC to soar - Your drone journey begins here!",
  },
  {
    img: "/Add on Course Images/FPV (1).jpg",
    title: "FPV",
    description:
      "See the sky like never before -FPV flying puts you in the pilot's seat!",
  },
];

// const servicesData = [
//   { title: "Small RPC", img: "/1.jpg", btn: "Get Started" },
//   { title: "Medium RPC", img: "/2.jpg", btn: "Get Started" },
//   { title: "Small + Medium RPC", img: "/3.jpg", btn: "Get Started" },
// ];
const servicesData = [
  { id: "68b98c0ac7f6b01f006db345", title: "Small RPC", img: "/1.jpg"},
  { id: "68b98facc7f6b01f006db369", title: "Medium RPC", img: "/2.jpg"},
  { id: "68b99107c7f6b01f006db37a", title: "Small + Medium RPC", img: "/3.jpg" },
];


const additionalServices = [
  { id :"68baa7a11786fb8c549aeb02",title: "Aerial Mapping and Surveying", img: "/Add on Course Images/Drone images.jpg", btn: "Get Started" },
  { id :"68baa89f1786fb8c549aeb14",title: "FPV Training", img: "/Add on Course Images/FPV.jpg", btn: "Get Started" },
  { id:"68baa9341786fb8c549aeb18",title: "Agriculture Drone", img: "/Add on Course Images/Agri Drone.jpg", btn: "Get Started" },
];

const statsData = [
  { number: 100, suffix: "+", label: "RPC" },
  { number: 5, suffix: "+", label: "Instructors" },
  { number: 100, suffix: "+", label: "Reviews" },
];

const testimonials = [
  { name: "Harini D", review: "Highly recommend Flytutor Academy- RPTO Training centre! the staff were friendly, approchable, and genuinely passionate about teaching, making the learning experience engaging and stress-free.", rating: 5 },
  { name: "Kannan Nelima", review: "From day one , it felt like a family atmosphere- all staff and atmosphere were very ", rating: 4 },
  { name: "Krishnendhu", review: "Flytutor Rpto is a well structured training organization that provides hands- on learning for drone pilots.their instructors are highly knowledgable, and they focus equally on theory , simulation and practical flying.", rating: 5 },
];


// ================= HOME COMPONENT =================
const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timeoutRef = useRef(null);
  const [animatedStats, setAnimatedStats] = useState(statsData.map(() => 0));
  const navigate = useNavigate(); // ✅ added
  // Contact form state
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  // Collaborators state
  const [collaborators, setCollaborators] = useState([]);

  const nextSlide = () => setActiveIndex((prev) => (prev + 1) % slides.length);
  // const prevSlide = () => setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);


  //Popup state
const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      nextSlide();
    }, 5000);
    return () => clearTimeout(timeoutRef.current);
  }, [activeIndex]);

  // const slide = slides[activeIndex];

  // ================= ANIMATE STATS =================
  useEffect(() => {
    const duration = 2000;
    const frameRate = 30;
    const totalFrames = Math.round(duration / (1000 / frameRate));
    const counters = statsData.map((stat) => {
      const increment = stat.number / totalFrames;
      return { increment, target: stat.number };
    });

    let frame = 0;
    const interval = setInterval(() => {
      frame++;
      setAnimatedStats((prevStats) =>
        prevStats.map((_, idx) =>
          Math.min(Math.round(counters[idx].increment * frame), counters[idx].target)
        )
      );
      if (frame === totalFrames) clearInterval(interval);
    }, 1000 / frameRate);

    return () => clearInterval(interval);
  }, []);




  // ================= CONTACT FORM =================
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch(process.env.REACT_APP_API_URL+"/home", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("✅ Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("❌ Failed to send message. Try again.");
      }
    } catch (error) {
      console.error(error);
      setStatus("⚠ Server error. Please try later.");
    }
  };

  // ================= FETCH COLLABORATORS =================
  useEffect(() => {
      fetch(process.env.REACT_APP_API_URL+"/admin/images")
      // fetch(process.env.REACT_APP_API_URL+"/admin/images")
      .then((res) => res.json())
      .then((data) => setCollaborators(data))
      .catch((err) => console.error("Error fetching collaborators:", err));
  }, []);

  return (
//     <div className="home-container">
//       {/* ===== HERO SLIDER ===== */}
// <section className="carousel">
//   {slides.map((s, index) => (
//     <div
//       key={index}
//       className={`carousel-slide ${activeIndex === index ? "active" : ""}`}
//     >
//       <img src={s.img} alt={s.title} className="carousel-image" />
//       <div className="overlay"></div>
//       {activeIndex === index && (
//         <div className="carousel-text">
//           <h1>{s.title}</h1>
//           <p>{s.description}</p>
//           <button className="primary-btn" onClick={() => navigate("/course")}>
//             Explore More
//           </button>
//         </div>
//       )}
//     </div>
//   ))}

//   {/* dots */}
//   <div className="dots">
//     {slides.map((_, idx) => (
//       <span
//         key={idx}
//         className={`dot ${activeIndex === idx ? "active" : ""}`}
//         onClick={() => setActiveIndex(idx)}
//       />
//     ))}
//   </div>
// </section>
<div className="home-container">
  {/* ===== HERO SLIDER ===== */}
  <section className="carousel">
    {slides.map((s, index) => (
      <div
        key={index}
        className={`carousel-slide ${activeIndex === index ? "active" : ""}`}
      >
        <img src={s.img} alt={s.title} className="carousel-image" />
        <div className="overlay"></div>
        {activeIndex === index && (
          <div className="carousel-text">
            <h1>{s.title}</h1>
            <p>{s.description}</p>
            <button
              className="primary-btn"
              onClick={() =>
                index === slides.length - 1
                  ? navigate("/certificate") // ✅ last slide → Certificate
                  : navigate("/course") // ✅ other slides → Courses
              }
            >
              {index === slides.length - 1 ? "Explore More" : "Explore More"}
            </button>
          </div>
        )}
      </div>
    ))}

    {/* dots */}
    <div className="dots">
      {slides.map((_, idx) => (
        <span
          key={idx}
          className={`dot ${activeIndex === idx ? "active" : ""}`}
          onClick={() => setActiveIndex(idx)}
        />
      ))}
    </div>
  </section>





      {/* ===== SERVICES ===== */}
      <section className="services-section section-padding">
        <h2 className="ourService">Our Services</h2>
        <div className="grid">
          {servicesData.map((s, i) => (
            <div key={i} className="cards">
              <div className="cards-inner">
                <div className="cards-front">
                  <img src={s.img} alt={s.title} />
                  <h3>{s.title}</h3>
                </div>
                <div className="cards-back">
                  <h3>{s.title}</h3>
                  <p>
                    This is more about <b>{s.title}</b>. Learn and explore with Flytutor experts.
                  </p>
                  {/* <button className="secondary-btn" onClick={() => navigate("/course")}>
                    Explore More
                  </button> */}
                 <button
              className="secondary-btn"
              onClick={() => navigate(`/course-enroll-template/${s.id}`)}
            >
              Explore More
            </button>

                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== INFRASTRUCTURE ===== */}
      <section className="infra-section">
        <div className="infra-overlay"></div>
        <div className="infra-container">
          <h2 className="ourService">Our Infrastructure</h2>
          <div className="infra-flex">
            <div className="infra-text">
              <p>
                Flytutor is a global pioneer in drone training and innovation,
                empowering students and businesses with cutting-edge AI-driven drone solutions,
                advanced aerial photography, and next-generation hybrid technologies.
              </p>
            </div>
            <div className="infra-video">
              <video width="420" controls autoPlay muted loop>
                <source src="fly_video.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>
      {/* ===== SERVICES ===== */}




      {/* ===== ADDITIONAL SERVICES ===== */}
      <section className="services-section section-padding">
        <h2 className="ourService">Add On Courses</h2>
        <div className="grid">
          {additionalServices.map((s, i) => (
            <div key={i} className="cards">
              <div className="cards-inner">
                <div className="cards-front">
                  <img src={s.img} alt={s.title} />
                  <h3>{s.title}</h3>
                </div>
                <div className="cards-back">
                  <h3>{s.title}</h3>
                  <p>More details about {s.title} will go here.</p>
                <button
              className="secondary-btn"
              onClick={() => navigate(`/certificate-enroll-template/${s.id}`)}
            >
              Learn More
            </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== STATS ===== */}
      <section className="stats-section">
        <h2 className="ourService">Our Achievements</h2>
        <div className="stats-grid">
          {statsData.map((stat, i) => (
            <div key={i} className="stat-card">
              <h2 className="stat-number">
                {animatedStats[i]}
                {stat.suffix}
              </h2>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* {/facilities section/} */}
<section className="facilities-section">
  <div className="container">
    <h2 className="ourService">Our Facilities</h2>
    <div className="facilities-grid">
      {/* Top row - 4 containers */}
      <div className="facility-item">
        <div className="facility-image-container">
          <img src="/Add on Course Images/IMG_6269.jpeg"alt="Modern Classrooms" />
        </div>
        <h3>Modern Classrooms</h3>
        <p>Intelligent drones transform modern classrooms,
           merging aviation and interactive education to create immersive,
            hands-on learning experiences that inspire innovation.


</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="/Add on Course Images/WhatsApp Image 2025-07-09 at 10.17.20 AM.jpeg" alt="Expert Instructors" />
        </div>
        <h3>Expert Instructors</h3>
        <p>Learn from DGCA-approved expert instructors who combine deep aviation knowledge with interactive teaching,
          ensuring safe, professional, and future-ready drone training.</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="./carrier_support.jpg" alt="Learning Resources" />
        </div>
        <h3>Placement Support</h3>
        <p>We provide dedicated placement support, connecting students with leading companies,
           ensuring career readiness, industry exposure, and opportunities for growth.</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="community_hub.jpg" alt="Community Spaces" />
        </div>
        <h3>Community Members</h3>
        <p>Join our vibrant community of learners, instructors, and innovators—collaborating,
           sharing knowledge, and growing together through meaningful connections.</p>
      </div>

      {/* Bottom row - 4 containers */}
      <div className="facility-item">
        <div className="facility-image-container">
          <img src="/Add on Course Images/WhatsApp Image 2025-07-08 at 8.25.28 PM.jpeg" alt="drone lab" />
        </div>
        <h3>Drone Lab</h3>
        <p>Our state-of-the-art Drone Lab offers hands-on training,
          research opportunities, and innovation space,
           empowering learners to master aerial technology.

</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="/Add on Course Images/library.jpg" alt="Library" />
        </div>
        <h3>Library</h3>
        <p>Our Drone Library offers extensive resources—manuals, research papers,
          and digital content—empowering learners to explore, innovate, and excel.</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="./greenery_acre.jpg" alt="acre" />
        </div>
        <h3> 24 Acre Greenery Space</h3>
        <p>Our greenery space provides a refreshing environment with natural surroundings,
           promoting relaxation, creativity, and wellness alongside academic excellence.</p>
      </div>

      <div className="facility-item">
        <div className="facility-image-container">
          <img src="./hostel.jpg" alt="hostel" />
        </div>
        <h3> Hostel</h3>
        <p>Our AC hostel ensures comfortable living with modern facilities,
          creating a safe, convenient, and student-friendly environment for learning and growth


</p>
      </div>
    </div>
  </div>
</section>

      {/* ===== TESTIMONIALS ===== */}
      <section className="testimonials-section section-padding">
        <h2 className="ourService">What Our Students Say</h2>
        <div className="testimonials">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <p>"{t.review}"</p>
              <div className="stars">
                {"★".repeat(t.rating)}
                {"☆".repeat(5 - t.rating)}
              </div>
              <h4>- {t.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* ===== COLLABORATORS ===== */}
     <div className="collaboration-slider">
  <h2 className="ourService">Our Collaborations</h2>
  {/* <div className="title-underline"></div> */}

  <div className="slider-track">
    {[...collaborators, ...collaborators].map((collaborator, index) => (
      <div key={index} className="collaboration-logo">
        <div className="logo-container">
          <img
            src={process.env.REACT_APP_API_URL+`${collaborator.url}`}
            alt={collaborator.filename || "Partner Logo"}
          />
        </div>
      </div>
    ))}
  </div>
</div>


      {/* ===== CONTACT ===== */}
      <div className="contact-page">
        <h2 className="ourService">Contact Us</h2>
        <p className="contact-subtitle">Get in touch with us for any queries or support.</p>
        <div className="contact-grid">
          <div className="contact-left">

  <iframe
    title="Flytutor Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.113137918836!2d78.0272093!3d11.326440500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babdbb297734803%3A0xd05a3e9e2582d7b4!2sFlytutor%20RPTO%20Training%20Cente!5e0!3m2!1sen!2sin!4v1756737038335!5m2!1sen!2sin"
    width="100%"
    height="350"
    style={{ border: 0, borderRadius: "8px" }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>

          </div>
          <div className="contact-right">
            <h3>Send a Message</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your message..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <button type="submit" className="contact-btn">
                Send Message
              </button>
            </form>
            {status && <p className="form-status">{status}</p>}
          </div>
        </div>
      </div>

      {/* ===== POPUP ===== */}
      {showPopup && <Popup onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default Home;

